import React, { Component } from 'react';
import { URLImgFront } from '../../config/URLDB';
//RQTO. CDAT Y AHORRO DIGITAL, AP 2025 
import { BeneficiosProductos_ } from '../../services/WebAPI_Utrahuilca';
import { MDBIcon } from 'mdbreact';

class Seccion3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DataBeneficiosProductos: [],
        };
    }

    //RQTO. CDAT Y AHORRO DIGITAL - AJUSTES SEGUNDA ENTREGA 2025 - AP 
    componentDidMount() {
        this.setState({ DataBeneficiosProductos: [] });
        const dataBenef = {
            tran: 6,
            estado: 1
        }
        BeneficiosProductos_(dataBenef).then(response => {
            try {
                if (response.data.length > 0) {

                    this.setState({
                        DataBeneficiosProductos: response.data,
                    })

                } else {
                    this.setState({ DataBeneficiosProductos: [] });
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    render() {
        return (
            <React.Fragment>
                <div className="product-image-container" style={{ background: '#f3f3f3', width: '100%' }}>
                    <div className="container py-0">
                        <div className="row px-0 py-0">
                            <div className="col-md-6 d-flex align-items-center justify-content-center py-2 pb-2">
                                <img style={{ width: '100%' }} className="img-fluid" src={`${URLImgFront}/assets${this.props.rutaimginferior}`} alt="img-1" />
                            </div>
                            <div className="col-md-6 d-flex align-items-center pl-5 py-5">
                                <div className="text-left">
                                    <p className="font-weight-bold" style={{ fontSize: '24px', color: '#6a6969' }}>{this.props.titulo1inferior}</p>

                                    {/* RQTO. CDAT Y AHORRO DIGITAL - AJUSTES SEGUNDA ENTREGA 2025 - AP */}
                                    {this.state.DataBeneficiosProductos.length > 0 ? (
                                        <ul style={{ listStyleType: 'none', padding: 0, marginBottom: '30px' }}>
                                            {this.state.DataBeneficiosProductos.map((item, index) => (
                                                <li key={item.id || index} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                                    <MDBIcon icon="check-circle" style={{ color: 'rgb(240, 127, 0)', marginRight: '10px' }} />
                                                    <span style={{ fontSize: '20px', color: '#6a6969' }}>{item.descbenef}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p style={{ fontStyle: 'italic' }}>Cargando Beneficios...</p>
                                    )}

                                    <p style={{ fontSize: '20px', color: '#6a6969' }}>{this.props.desc1inferior}</p>
                                    <p className="my-0 py-0" style={{ fontSize: '24px', color: '#6a6969', fontWeight: 'bold' }}>{this.props.titulo2inferior === 'N/A' ? '' : this.state.titulo2inferior}</p>
                                    <p className="my-0 py-0" style={{ fontSize: '20px', color: '#6a6969' }}>{this.props.desc2inferior === 'N/A' ? '' : this.state.desc2inferior}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment> 
        );
    }
}

export default Seccion3;